import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { privacyPoints, stats } from "@/mocks/home";

export default function Privacy() {
  return (
    <section id="privacy" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="grid grid-cols-1 items-start gap-10 md:gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative w-full overflow-hidden rounded-lg border border-background-200/70">
              <div className="h-[320px] w-full md:h-[520px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimal%20still%20life%20photograph%20of%20a%20sealed%20manila%20envelope%20and%20stacked%20blank%20paper%20on%20a%20warm%20cream%20linen%20surface%2C%20single%20soft%20directional%20daylight%20creating%20a%20long%20gentle%20shadow%2C%20muted%20sand%20and%20terracotta%20tones%2C%20editorial%20fine%20art%20photography%2C%20shallow%20depth%20of%20field%2C%20generous%20empty%20space%20around%20the%20subject%2C%20calm%20confidential%20mood%2C%20no%20text%20on%20the%20paper%2C%20high%20detail&width=900&height=1120&seq=hl-privacy-01&orientation=portrait"
                  alt="匿名投稿渠道隐私保护密封信封静物"
                  title="黑料投稿联系方式 隐私保护承诺"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal delay={80}>
              <SectionHeading
                kicker="Privacy Promise"
                title="严格保密，是匿名投稿渠道的底线"
                description="我们理解每一次投稿都需要勇气。因此从材料接收、存储到反馈，都把匿名与保密放在第一位，让您无后顾之忧。"
              />
            </Reveal>

            <div className="mt-10 grid grid-cols-1 gap-3 md:gap-4 sm:grid-cols-2">
              {privacyPoints.map((point, index) => (
                <Reveal key={point.title} delay={index * 80} className="h-full">
                  <article className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${point.icon} text-lg`} />
                    </span>
                    <h3 className="mt-4 font-heading text-base text-foreground-950">{point.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                  </article>
                </Reveal>
              ))}
            </div>

            <Reveal delay={160}>
              <dl className="mt-10 grid grid-cols-2 gap-y-6 border-t border-background-200/70 pt-8 sm:grid-cols-4">
                {stats.map((stat) => (
                  <div key={stat.label}>
                    <dd className="font-heading text-2xl text-accent-600 md:text-3xl">
                      {stat.value}
                    </dd>
                    <dt className="mt-2 font-label text-xs text-foreground-500">{stat.label}</dt>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}